<button
  *ngIf="showRootButton"
  class="btn contact-button d-print-none"
  (click)="open(getInTouchContent)">
  Help Center
</button>
<ng-template #getInTouchContent let-getHelpModal>
  <div class="get-help-modal" [class.w-100]="!showButtons">
    <div class="modal-header get-help-modal-header">
      <h3 class="mx-auto modal-title get-help-modal-title">
        <span *ngIf="showButtons">Help Center</span>
        <span *ngIf="showIdeaForm">Share Idea</span>
        <span *ngIf="showContactForm && showCsrContactForm">Get Help</span>
      </h3>
      <button type="button" class="btn ms-0" aria-label="Close" (click)="getHelpModal.dismiss()">
        <img src="assets/icons/Shapenull.svg" />
      </button>
    </div>
    <div class="modal-body">
      <div class="row" *ngIf="showButtons">
        <div class="col-12 mb-3" *ngIf="showIdeaButton">
          <button
            (click)="ideaButtonClicked()"
            type="button"
            class="btn get-help-modal-button"
            ngbAutoFocus>
            <div class="d-flex align-items-center">
              <div class="me-2">
                <img src="assets/icons/lightbulb.svg" />
              </div>
              <div class="text-start">
                <h5 class="fw-bold mt-1">Share Idea</h5>
              </div>
            </div>
          </button>
        </div>
        <div class="col-12 mb-3" *ngIf="showContactButton || showCsrContactForm">
          <button
            (click)="contactButtonClicked()"
            *ngIf="showCsrContactForm"
            type="button"
            class="btn get-help-modal-button">
            <div class="d-flex align-items-center">
              <div class="me-2">
                <img src="assets/icons/support.svg" />
              </div>
              <div class="text-start">
                <h5 class="fw-bold mt-1">Submit a Support Ticket</h5>
              </div>
            </div>
          </button>
          <a
            href="https://connectpay.zohodesk.com/portal/en/myarea"
            target="_blank"
            *ngIf="!showCsrContactForm"
            class="btn get-help-modal-button">
            <div class="d-flex align-items-center">
              <div class="me-2">
                <img src="assets/icons/support.svg" />
              </div>
              <div class="text-start">
                <h5 class="fw-bold mt-1">Submit a Support Ticket</h5>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 mb-3" *ngIf="showFaqButton">
          <a
            href="https://connectpay.zohodesk.com/portal/en/kb"
            target="”_blank”"
            class="btn get-help-modal-button">
            <div class="d-flex align-items-center">
              <div class="me-2">
                <img src="assets/icons/faq.svg" />
              </div>
              <div class="text-start">
                <h5 class="fw-bold mt-1">Frequently Asked Questions</h5>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <lib-share-idea-form
        (formSubmitted)="closeModal()"
        *ngIf="showIdeaForm"></lib-share-idea-form>
      <lib-zoho-widget-form *ngIf="showContactForm && showCsrContactForm"></lib-zoho-widget-form>
    </div>
  </div>
</ng-template>
